
import ProductFunctions from '~/mixins/ProductFunctions'

export default {
  mixins: [ProductFunctions],

  props: {
    shoppingListCode: {
      type: String,
      default: null,
    },

    product: {
      type: Object,
      required: true,
    },

    small: {
      type: Boolean,
      default: false,
    },

    hideDeleteButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hovered: false,
    }
  },

  computed: {
    authorList() {
      if (
        !Array.isArray(this.product.authors) ||
        !this.product.authors.length
      ) {
        return ''
      }

      return this.product.authors.map((author) => author.title).join(', ')
    },
  },
}
